import HTML from "../assets/html.png";
import CSS from "../assets/css.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import Mongo from "../assets/mongo.png";
import Git from "../assets/Git.png";
import Express from "../assets/expressjs.png";

const SkillData = [
  {
    id: 1,
    image: HTML,
    alt: "HTML icon",
    title: "HTML",
  },
  {
    id: 2,
    image: CSS,
    alt: "CSS icon",
    title: "CSS",
  },
  {
    id: 3,
    image: JavaScript,
    alt: "Javascript icon",
    title: "JAVASCRIPT",
  },
  {
    id: 4,
    image: ReactImg,
    alt: "React icon",
    title: "REACT",
  },
  {
    id: 5,
    image: Git,
    alt: "Git icon",
    title: "GIT",
  },
  {
    id: 6,
    image: Node,
    alt: "Node icon",
    title: "NODE JS",
  },
  {
    id: 7,
    image: Express,
    alt: "Express icon",
    title: "EXPRESS",
  },
  {
    id: 8,
    image: Mongo,
    alt: "Mongo DB icon",
    title: "MONGO",
  },
];

export default SkillData;
